import { InjectionToken } from '@angular/core';
import { initClient } from '@ts-rest/core';
import { staplesVRContract } from '@thred/staplesvr-common';
import { InitClientArgs } from '@ts-rest/core/src/lib/client';

export type StaplesVRClientType = ReturnType<
  typeof initClient<typeof staplesVRContract, InitClientArgs>
>;
export const STAPLESVR_CLIENT_TOKEN =
  new InjectionToken<StaplesVRClientType>('StaplesvrClientToken');